import {Injectable} from '@angular/core';
import {Rect} from 'konva/lib/shapes/Rect';
import {GraphKnDataService} from './graph-kn.data.service';
import {GraphKnLayerService} from './graph-kn.layer.service';
import {LayOutService} from './graph-kn.layout.service';
import {Group} from 'konva/lib/Group';
import {Layer} from 'konva/lib/Layer';
import {GraphKnConnectorsLayersService} from './graph-kn.connectros-layers.service';
import Konva from 'konva';
import {KN_ICONS_MAP} from '../models/graph-kn-icons-map';
import {GraphKnUIElementsService} from './graph-kn.ui.elements.service';
import {BUSINESS_PROCESS_LAYER_ID, CONTRACT_LAYER_ID, IKnGraphSettings, Node} from '../models/graph-kn.cm-api-models';
import {ILayerData, TGraphType} from '../models/graph-kn.model-interfaces';
import {COLOR_TASK_LAYER} from '../models/graph-kn.cm.layers-model-const';
import {GraphKnEdgesConnectorsService } from './graph-kn.edges-connectros.service';
import { RectModelsMap } from '../styles/graph-node-rect-model';
import { GraphKnNodeEventsService } from './graph-kn.node-events.service';
import { GraphKnStageService } from './graph-kn.stage.service';
import { GraphKnNodeTargetsService } from './graph-kn.node-targets.service';

@Injectable({
    providedIn: 'root'
})
export class GraphKnLayerSettingService {

	constructor(
		private knStageService: GraphKnStageService,
		private knNodeTargetsService: GraphKnNodeTargetsService,
		private knEdgesConnectorsService: GraphKnEdgesConnectorsService,
		private knDataService: GraphKnDataService,
		private knLayerService: GraphKnLayerService,
		private knConnectorsService: GraphKnConnectorsLayersService,
		private knUIElementsService: GraphKnUIElementsService,
        private knNodeEventsService: GraphKnNodeEventsService,
		private layOutService: LayOutService,
	) {	}

	updateLayer(layerIdID: string, layerData: ILayerData, layerID: TGraphType) {
		let graphData = this.knDataService.contractGD.get(layerIdID);
		let layoutSettings = this.knDataService.layoutDagreSettings.get(layerID)
		let graphSettings:IKnGraphSettings = {
			layoutAlgorithm:layoutSettings?.algorithmEdges,
			edgeType:layoutSettings?.edgeType,
			edgePointerType:layoutSettings?.pointerType,
		}
		let contractNodes = this.knNodeTargetsService.generateTargetsNodes(graphData, this.knDataService.topNodeYpos, layerData, layerID);
		this.knDataService.contractNodes.set(layerIdID, contractNodes)
		this.knDataService.contractsEdges = this.knEdgesConnectorsService.generateConnectorsEdges(graphData, contractNodes, this.knDataService.topNodeYpos, layerID);
		this.knStageService.generateStage(contractNodes, this.knDataService.contractsEdges, layerData, layerID,graphSettings)
		this.layOutService.updateGraph(this.knDataService.contractsEdges, layerData.layer,undefined,undefined,undefined,layerID);
	}

	setContractLayer(layerId: string, setNewLayer: boolean = true, fill?: string, bottomLayer = false) {
        let conractLayerData: ILayerData | undefined
        if (setNewLayer) {
            conractLayerData = this.knLayerService.createLayer(
                this.knDataService.graphStage,
                this.knDataService.layoutDagreSettings.get(CONTRACT_LAYER_ID) || this.knDataService.defaultDagreSetting,
                //layerId,
                CONTRACT_LAYER_ID,
                this.knDataService.canvasObjectsMap,
                bottomLayer,
                fill
            )
            this.createCloseButton(conractLayerData.layer, conractLayerData.dragRect, layerId);
            this.knDataService.layersMap.set(layerId, {...conractLayerData})
        } else {
                conractLayerData = this.knDataService.layersMap.get(layerId)
                conractLayerData?.layer.removeChildren()
                conractLayerData?.layer.add(conractLayerData.dragRect)
        }
        let rectModel = RectModelsMap.get('contractStep')
        if (this.knDataService.layoutDagreSettings.get(CONTRACT_LAYER_ID)?.nodeWidthAdaptive) {
        } else {
            this.knDataService.nodeWidth = rectModel!.width!
        }
			conractLayerData ? this.updateLayer(layerId, conractLayerData, CONTRACT_LAYER_ID) : null;
			this.knLayerService.adjustBPLayer()
	};

	setBusinessProcessLayer(): ILayerData | undefined {
			let bpLayer = this.knDataService.layersMap.get(BUSINESS_PROCESS_LAYER_ID)
			if (bpLayer) {
					return bpLayer
			}
			let businessProcessLayerData = this.knLayerService.createLayer(
					this.knDataService.graphStage,
					this.knDataService.layoutDagreSettings.get(BUSINESS_PROCESS_LAYER_ID) || this.knDataService.defaultDagreSetting,
					BUSINESS_PROCESS_LAYER_ID,
					this.knDataService.canvasObjectsMap,
					true,
					COLOR_TASK_LAYER
			)
			this.knDataService.layersMap.set(BUSINESS_PROCESS_LAYER_ID, {...businessProcessLayerData})
			this.knDataService.graphStage.add(businessProcessLayerData.layer)
			return businessProcessLayerData
	}

	removeBPLayer() {
			let layer = this.knDataService.layersMap.get(BUSINESS_PROCESS_LAYER_ID)?.layer
			let closeGroupBP = layer?.findOne('#' + BUSINESS_PROCESS_LAYER_ID + '_Close')
			let contractLayer = this.knDataService.layersMap.get(CONTRACT_LAYER_ID)?.layer
			let backGroundRect = layer?.findOne('#' + BUSINESS_PROCESS_LAYER_ID)
			if (layer) {
					layer.removeChildren();
					backGroundRect ? layer.add(backGroundRect as Rect) : null
					closeGroupBP ? layer.add(closeGroupBP as Group) : null
					layer.draw();
			}
			contractLayer ? contractLayer.findOne('#' + 'LinkToActiveStep')?.destroy() : null
	}

	prepareBPLayer(layerData: ILayerData) {
		this.knDataService.subToolBarOpen.next({left:0,top:0,visibility:'hidden'})
		let activateOptions = this.knDataService.graphUISetting.get(BUSINESS_PROCESS_LAYER_ID);
		this.knDataService.businessProcessGD.activeStepId = this.knDataService.activeStepId;
		this.knDataService.nodeHeight = 0;
		this.knDataService.nodeWidth = 0;
		let layerDataBP = this.knDataService.layersMap.get(BUSINESS_PROCESS_LAYER_ID)
		let contractLayerId = this.knDataService.selectedNodeGroup?.parent?.children?.filter(el => el instanceof Rect)[0].attrs.id || BUSINESS_PROCESS_LAYER_ID
		let layerDataContract = this.knDataService.layersMap.get(CONTRACT_LAYER_ID)
		if (layerDataBP) {
			let dargeSettings = this.knDataService.layoutDagreSettings.get(BUSINESS_PROCESS_LAYER_ID);
			let graphSettings:IKnGraphSettings = {
				layoutAlgorithm:dargeSettings?.algorithmEdges,
				edgeType:dargeSettings?.edgeType,
				edgePointerType:dargeSettings?.pointerType,
			}
			this.layOutService.prepareLayoutInit(
				this.knDataService.businessProcessGD, this.knDataService.layoutDagre, layerDataBP.dimensions
			).subscribe(res=>{
				this.knDataService.topNodeYpos = Math.min(...this.knDataService.businessProcessGD.nodes.map(nd => (nd as Node).position?.y || 0)) - 10;
	
				this.knDataService.businessProcessNodes = 
					this.knNodeTargetsService.generateTargetsNodes
					(this.knDataService.businessProcessGD, this.knDataService.topNodeYpos, layerData, BUSINESS_PROCESS_LAYER_ID);
	
				this.knDataService.businessProcessEdges = 
					this.knEdgesConnectorsService.generateConnectorsEdges
						(this.knDataService.businessProcessGD, this.knDataService.businessProcessNodes, this.knDataService.topNodeYpos);
	
				this.knStageService.generateStage(
					this.knDataService.businessProcessNodes, this.knDataService.businessProcessEdges, 
					layerDataBP, BUSINESS_PROCESS_LAYER_ID,
					graphSettings
				);
	
				if (layerDataContract && this.knDataService.businessProcessGD.activeStepId) {
					this.knConnectorsService.createLinkToActiveStep(layerDataBP.layer, this.knDataService.businessProcessGD.activeStepId, contractLayerId)
                    let toNode = layerDataBP.layer.findOne('#' + this.knDataService.businessProcessGD.activeStepId.toString()) as Group
                    this.knNodeEventsService.toggleActiveNodeMode(toNode,this.knDataService.businessProcessEdges)
                }
	
				activateOptions?.closeLayerButton? this.createCloseButton(layerDataBP.layer, layerDataBP.dragRect, BUSINESS_PROCESS_LAYER_ID) : null;
			});

		}
	}

	createCloseButton(newLayer: Layer, dragLayerRect: Rect, layerId: string) {
			if (newLayer.findOne('#' + BUSINESS_PROCESS_LAYER_ID + '_Close')) {
					return
			}
			let closeGroup = new Group({
					id: layerId === BUSINESS_PROCESS_LAYER_ID ? BUSINESS_PROCESS_LAYER_ID + '_Close' : layerId,
					draggable: false,
					fill: 'grey',
					opacity: 0.6,
					x: dragLayerRect.x(),
					y: dragLayerRect.y()
					//y: dragLayerRect.y() + dragLayerRect.height() + 10
			});
			let tooltipGroup: Group;
			let icon = KN_ICONS_MAP.get('CLOSE_ICON')!
			Konva.Image.fromURL(icon.path, (image) => {
					image.scale(icon.scale)
					image.offsetY(icon.offsetY)
					tooltipGroup = this.knUIElementsService.createToolTip(image, 'GRAPH.BUTTONS.TOOLTIPS.LAYER_CLOSE', 14, 1, 'white', 0, 5).group
					closeGroup.add(image)
					closeGroup.add(tooltipGroup)
			});
			newLayer.add(closeGroup)
			closeGroup.on('click', () => closeGroup.id().includes(BUSINESS_PROCESS_LAYER_ID) ? this.closeBPLayer(closeGroup) : this.closeContractLayer(closeGroup))
			closeGroup.on('mouseover', () => {
					document.body.style.cursor = 'pointer';
					tooltipGroup.show()
			})
			closeGroup.on('mouseout', () => {
					document.body.style.cursor = 'default';
					tooltipGroup.hide()
			})
	}

	closeContractLayer(closeGroup: Group) {
			let leayer = this.knDataService.layersMap.get(closeGroup.id().replace('_Close', ''))?.layer
			let layerId = closeGroup.attrs.id
			this.knDataService.contractGD.delete(layerId);
			this.knDataService.contractNodes.delete(layerId);
			this.knDataService.contractsEdges.pop();
			leayer?.destroy()
			this.knDataService.layersMap.delete(closeGroup.id())
			this.knDataService.contractConnectors
					.filter(ce => [ce.toLayerID, ce.fromLayerID].includes(closeGroup.attrs.id))
					?.forEach((ce, index) => {
							ce.arrow.destroy();
							this.knDataService.contractConnectors.splice(index, 1);
					})
			let bottomLayerID = Array.from(this.knDataService.layersMap.keys()).filter(el => el !== BUSINESS_PROCESS_LAYER_ID).sort();
			this.knLayerService.adjustBPLayer()
	}

	closeBPLayer(closeGroup: Group) {
			let leayer = this.knDataService.layersMap.get(closeGroup.id().replace('_Close', ''))?.layer;
			this.knDataService.linkEdge.destroy();
			this.knDataService.businessProcessGD = {nodes: [], edges: []};
			this.knDataService.businessProcessEdges = [];
			this.knDataService.businessProcessNodes = [];
			this.knDataService.layersMap.delete(BUSINESS_PROCESS_LAYER_ID)
			leayer?.destroy();
	}
}